import { array } from "prop-types";
import React, { useEffect, useState } from "react";

import NewsWithImage from "../../../molecules/NewsWithImage";

import "./organism2.m.css";

const Organism2 = ({ storyList }) => {
  const [showCardDetails, setShowCardDetails] = useState(false);

  useEffect(() => {
    global.deviceWidth > 1263 && setShowCardDetails(!showCardDetails);
  }, []);

  return (
    <div styleName="base">
      {storyList.map(({ story }, index) => (
        <NewsWithImage story={story} key={index} />
      ))}
    </div>
  );
};

Organism2.propTypes = {
  storyList: array.isRequired,
};

export default Organism2;
